module.exports = __webpack_public_path__ + "static/averta-semibold-b22035c3015b7bbf2574585c3be514f2.woff";